/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Link from "next/link";
import React from "react";
import styles from "gui/entries/entries.module.css";
import { Avatar } from "gui/avatar/avatar";
import { EntryDashboard } from "lib/entries/types";
import { EntryFavoritesText } from "gui/entries/favorites";
import { Icon } from "gui/icon/icon";
import { Tags } from "gui/tags/tags";
import { TimeRelative } from "gui/time/time";
import { isDashboardTrending } from "lib/entries/entries";
import { dashboardPath } from "lib/links/links";

interface Props {
  entry: EntryDashboard;
  color1?: boolean;
  avatar?: boolean;
  favorites?: boolean;
}

export const DashboardEntry: React.FC<Props> = (props) => {
  const { entry } = props;

  const entryTitle = entry.name || "Dashboards";
  const entryHref = dashboardPath(entry.owner.handle, entry.slug);
  const isTrending = isDashboardTrending(entry);

  return (
    <li className={styles.entry}>
      <div className={styles.image}>
        {props.avatar ? (
          <Link href={`/${entry.owner.handle}`}>
            <a>
              <Avatar
                src={entry.owner.profile_image_url}
                alt={entry.owner.name}
                size={25}
              />
            </a>
          </Link>
        ) : (
          <Icon icon="dashboard" />
        )}
      </div>

      <div className={styles.title}>
        <Link href={entryHref}>
          <a>
            {entryTitle}
            {isTrending && <span>&nbsp;🔥</span>}
          </a>
        </Link>
        {entry.tags && (
          <Tags
            slug="dashboards"
            tags={entry.tags}
            limit={5}
            color1={props.color1}
            className={styles.tags}
          />
        )}
      </div>

      <div className={styles.subtitle}>
        Created by{" "}
        <Link href={`/${entry.owner.handle}`}>
          <a>@{entry.owner.handle}</a>
        </Link>{" "}
        <TimeRelative>{entry.created_at}</TimeRelative>
        {entry.is_private && <Icon icon="lock-fill" />}
      </div>

      <div className={styles.favorites}>
        <EntryFavoritesText entry={entry} readOnly={!props.favorites} />
      </div>
    </li>
  );
};
